import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const goSection = (id) => (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#1A1A1A] text-[#FDFCFB] pt-20 md:pt-28 pb-8 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="caption !text-[#FDFCFB]/50 mb-4">Heritex Innovations Pvt. Ltd.</div>
            <p className="font-serif-display text-2xl md:text-3xl leading-snug max-w-md">
              A small, senior studio building products that quietly outlast trends.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="caption !text-[#FDFCFB]/50 mb-4">Offices</div>
            <p className="text-sm text-[#FDFCFB]/80 leading-relaxed">
              <span className="text-[#FDFCFB]/50">Head Office —</span><br />
              Mumbai, Maharashtra, India<br /><br />
              <span className="text-[#FDFCFB]/50">Registered Office —</span><br />
              Lucknow, Uttar Pradesh, India
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="caption !text-[#FDFCFB]/50 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" onClick={goSection("services")} className="hover:text-[#FDFCFB]/70 transition-colors">Services</a></li>
              <li><a href="#portfolio" onClick={goSection("portfolio")} className="hover:text-[#FDFCFB]/70 transition-colors">Portfolio</a></li>
              <li><a href="#process" onClick={goSection("process")} className="hover:text-[#FDFCFB]/70 transition-colors">Process</a></li>
              <li><a href="#contact" onClick={goSection("contact")} className="hover:text-[#FDFCFB]/70 transition-colors">Contact</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="caption !text-[#FDFCFB]/50 mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li><a href="tel:+919873117605" className="hover:text-[#FDFCFB]/70 transition-colors">+91 98731 17605</a></li>
              <li><a href="mailto:hello@heritexinnovation.com" className="hover:text-[#FDFCFB]/70 transition-colors break-all">hello@<br />heritexinnovation.com</a></li>
              <li className="pt-2"><a href="#" className="hover:text-[#FDFCFB]/70 transition-colors">LinkedIn</a></li>
              <li><a href="#" className="hover:text-[#FDFCFB]/70 transition-colors">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div
          aria-hidden
          className="font-serif-display leading-none tracking-tighter text-[24vw] md:text-[20vw] text-[#FDFCFB] -mb-[2vw] select-none pointer-events-none whitespace-nowrap text-center"
        >
          HERITEX
        </div>

        <div className="mt-10 pt-6 border-t border-[#FDFCFB]/15 flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-6 text-xs text-[#FDFCFB]/60">
          <div>
            © {year} Heritex Innovations Pvt. Ltd. · CIN forthcoming · All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="hover:text-[#FDFCFB] transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="hover:text-[#FDFCFB] transition-colors"
            >
              Terms
            </Link>
            <button
              data-testid={FOOTER.backToTop}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="inline-flex items-center gap-2 hover:text-[#FDFCFB]"
            >
              Back to top <ArrowUp className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
